import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { KeyValueSetInt, LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements OnInit {
  selectedHour = ''; selectedMinute = ''; isAm = true;
  @Input() id: string = ''; @Input() selectedTime = ''; @Input() isHorizontal = true; @Input() isDisabled: boolean = false;
  hours: KeyValueSetInt[] = []; minutes: KeyValueSetInt[] = [];
  @Output() onTimeUpdated= new EventEmitter();

  constructor(public localService: LocalService) { }

  ngOnInit(): void {
    if (this.id == '')
      this.id = this.localService.getRandomString(5);

    for (let i = 0; i < 12; i++) {
      this.hours.push({ key: i, value: (i.toString().length == 1 ? '0' : '') + i.toString() } as KeyValueSetInt);
    }

    for (let i = 0; i < 60; i++) {
      this.minutes.push({ key: i, value: (i.toString().length == 1 ? '0' : '') + i.toString() } as KeyValueSetInt);
    }

    if (this.selectedTime) {
      let time1 = this.selectedTime.split(' ');
      this.isAm = time1[1] == 'am';
      let time2 = time1[0].split(':');
      this.selectedHour = time2[0];
      this.selectedMinute = time2[1];
    } else {
      this.selectedHour = '';
      this.selectedMinute = '';
    }
  }

  onClick(index) {
    this.isAm = index == 1;
    this.onEmitValue();
  }

  onEmitValue() {
    this.selectedTime = (this.selectedHour != '' ? this.selectedHour : '00') + ':' + (this.selectedMinute != '' ? this.selectedMinute : '00')  + ' ' + (this.isAm ? 'am' : 'pm');
    this.onTimeUpdated.emit(this.selectedTime);
  }
}
